import CommonApi from './api/Common'
import Role from './api/Role'
import Organization from './api/Organization'
import User from './api/User'
import Excel from './api/Excel'
import Enum from './api/Enum'
import CanteenManagement from './api/CanteenManagement'

export default {
  ...CommonApi,
  ...Role,
  ...Organization,
  ...User,
  ...Excel,
  ...Enum,
  ...CanteenManagement
}
